import type { PLAElementRecord } from "./PLAState";

export function comparePLAElementsByDefaultOrder(left: PLAElementRecord, right: PLAElementRecord): number {
   const leftHasSortingNumber = typeof left.sortingNumber === "number" && Number.isFinite(left.sortingNumber);
   const rightHasSortingNumber = typeof right.sortingNumber === "number" && Number.isFinite(right.sortingNumber);
   if (leftHasSortingNumber && rightHasSortingNumber && left.sortingNumber !== right.sortingNumber) return left.sortingNumber! - right.sortingNumber!;
   if (leftHasSortingNumber && !rightHasSortingNumber) return -1;
   if (!leftHasSortingNumber && rightHasSortingNumber) return 1;
   return left.name.localeCompare(right.name, undefined, { numeric: true, sensitivity: "base" });
}
